import React, { useState } from 'react';
import { Form, Button, Input, Collapse } from 'antd';
import { User } from '../../models';
import { handleApiExceptions, alertify } from '../../app_methods';
import { EaseModal } from '../../libs/EaseModal';
import { Text1 } from '../../styles';
import CollapsePanel from 'antd/lib/collapse/CollapsePanel';


let ChangePasswordModal = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const [isSaving, setIsSaving] = useState(false);
    const password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;

    const validatePassword = (rule, value, callback) => {
        const new_password = form.getFieldValue("new_password");
        const new_password_repeat = value;
        if (new_password != new_password_repeat) callback("New passwords don't match.");
        else callback();
    };

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (err) return;
            setIsSaving(true);
            const user = new User(props.user);
            const response = await user.change_password({ id: user.id, old_password: values.old_password, new_password: values.new_password });
            if (!response.data.success) {
                console.log('false');
                setIsSaving(false);
                handleApiExceptions(response.data.message);
                return;
            } else {
                alertify("Success", response.data.message, "success");
            }
            setIsSaving(false);
            props.toggleChangePasswordModal();
        });
    };

    return (
        <EaseModal
            width={350}
            title={false}
            visible={props.visible}
            onCancel={props.toggleChangePasswordModal}
            centered
            hideFooter
            destroyOnClose
        >
            <Text1 className="d-block mb-4" strong>Change Password</Text1>
            <Form onSubmit={onSubmit}>
                <Form.Item label="Old password">
                    {getFieldDecorator('old_password', {
                        rules: [{ required: true, message: "Please enter your old password." }]
                    })(<Input autoComplete='off' type="password" />)}
                </Form.Item>
                <Form.Item label="New password">
                    {getFieldDecorator('new_password', {
                        rules:[{
                            required: true, message: "Please enter your new password."
                        }, {
                            pattern: password_regex, message: "Password does not match with policy. Please refer password policy."
                        }]
                    })(<Input autoComplete='off' type="password" />)}
                </Form.Item>
                <Form.Item label="Re-enter New password">
                    {getFieldDecorator('new_password_repeat', {
                        rules: [
                            { required: true, message: "Please re-enter your new password." },
                            { validator: validatePassword }
                        ]
                    })(<Input autoComplete='off' type="password" />)}
                </Form.Item>
                <Collapse className='mb-2' >
                    <CollapsePanel header="Password Policy" key="1">
                        <ul>
                            <li>Password must be at least 8 characters long.</li>
                            <li>Password must contain at least one lowercase letter (a-z).</li>
                            <li>Password must contain at least one uppercase letter (A-Z).</li>
                            <li>Password must contain at least one digit (0-9).</li>
                            <li>Password must contain at least one special character from the set !@#$%^&*.</li>
                        </ul>
                    </CollapsePanel>

                </Collapse>
                <div className="w-100 d-flex justify-content-end align-self-end mt-4">
                    <Button type="primary" htmlType="submit" loading={isSaving}>Submit</Button>
                </div>
            </Form>
        </EaseModal>
    )
};

ChangePasswordModal = Form.create()(ChangePasswordModal);

export { ChangePasswordModal };